@reference "~/styles.css";

@layer components {
	input[type="checkbox"] {
		/* Hide the native checkbox element,
    radix does not hide it but absolutely positions 1x1 element
    so it sometimes causes an extra scrollbar to appear.
    */
		@apply aria-hidden:contents;
	}

	.checkbox {
		@apply flex justify-center items-center shrink-0 text-base size-[1em] bg-white border border-grey-400 rounded-sm;
		@apply motion-safe:transition-colors;
		@apply hover:border-primary-500;

		@apply state-checked:text-primary-600 state-checked:border-current state-checked:bg-current;
		@apply state-checked:hover:text-primary-500;

		@apply state-indeterminate:text-primary-600;
		@apply state-indeterminate:hover:text-primary-500;

		@apply focus-visible:ring-2 ring-primary-500/30;
		/* focus-within turns on when focusing via JS HtmlElement.focus() */
		@apply focus-within:ring-2;

		@apply aria-disabled:cursor-not-allowed aria-disabled:text-grey-400 aria-disabled:border-current aria-disabled:bg-grey-100;
		@apply aria-disabled:state-checked:text-grey-500 aria-disabled:state-indeterminate:text-grey-500;

		@apply aria-busy:cursor-wait aria-busy:text-grey-400 aria-busy:border-current aria-busy:bg-grey-100;
		@apply aria-busy:state-checked:text-grey-500 aria-busy:state-indeterminate:text-grey-500;
	}

	.sm {
		@apply text-sm/none;
	}

	.md {
		@apply text-base/none;
	}

	.lg {
		@apply text-lg/none;
	}

	.label {
		@apply text-grey-800 cursor-pointer;

		&:where(&:has(.checkbox[aria-disabled="true"])),
		&:where(&:has(.checkbox[aria-busy="true"])) {
			@apply text-grey-500;
		}

		&:where(&:has(.checkbox[aria-disabled="true"])) {
			@apply cursor-not-allowed;
		}

		&:where(&:has(.checkbox[aria-busy="true"])) {
			@apply cursor-wait;
		}

		&:where(&:has(.sm)) {
			@apply text-xs/none;
		}

		&:where(&:has(.md)) {
			@apply text-13/none;
		}

		&:where(&:has(.lg)) {
			@apply text-sm/none;
		}
	}
}
